{
  "version": 1,
  "asset_id": "f3dfd477-c742-4e7f-b0ae-40dca5a5b475",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f3dfd477-c742-4e7f-b0ae-40dca5a5b475/carage-semrush-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f3dfd477-c742-4e7f-b0ae-40dca5a5b475/carage-semrush-640.avif",
  "original_filename": "carage-semrush-640.avif",
  "size": 9870,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:24Z"
}
